/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-01-23 11:21:19                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-01-23 13:56:11                               *
 *****************************************************************************/

/* SUMMARY
  * visitExportDescriptor: descriptor data/csv
*/

import { t } from "i18next";
import { formatLocalDate } from "../timezoneUtils";

/**
* visitExportDescriptor: descriptor data/csv
*/
export const prospectExportDescriptor: EasyTech.ExportDescriptor[] = [{
  column: "id",
  columnTranslationKey: "common:export.columns.id",
  // Identifiant technique, demandé pour rapprocher un export d'un autre système. Décoché comme
  // n'importe quelle autre colonne si le lecteur n'en a pas l'usage.
  getter: (e: { id?: string }) => e.id || ""
}, {
  column: "ref",
  columnTranslationKey: "common:ref.label",
  getter: (e: EasyTech.Prospect) => e.ref
}, {
  column: "date",
  columnTranslationKey: "common:date.label",
  getter: (e: EasyTech.Prospect) => {
    const realm = localStorage.getItem("realm") || "default";
    return e.date ? formatLocalDate(e.date, realm).split(" ")[0] : "";
  }
}, {
  column: "hour",
  columnTranslationKey: "common:export.columns.hour",
  getter: (e: EasyTech.Prospect) => e.hour
}, {
  column: "customer",
  columnTranslationKey: "common:customer",
  // Guarded like every other cell here: one visit with no customer used to throw and take the whole
  // export down, not just its own row.
  getter: (e: EasyTech.Prospect) => e.customer?.name || ""
}, {
  column: "technician",
  columnTranslationKey: "common:technician",
  getter: (e: EasyTech.Prospect) =>
    e.technician ? `${e.technician.firstName} ${e.technician.lastName}` : ""
}, {
  column: "contact",
  columnTranslationKey: "common:contact",
  getter: (e: EasyTech.Prospect) =>
    e.contact ? `${e.contact.firstName} ${e.contact.lastName}` : ""
}, {
  column: "Contact function",
  columnTranslationKey: "common:export.columns.contactFunction",
  getter: (e: EasyTech.Prospect) => e.contact?.function || ""
}, {
  column: "Contact E-mail",
  columnTranslationKey: "common:export.columns.contactEmail",
  getter: (e: EasyTech.Prospect) => e.contact?.contactInfo?.email || ""
}, {
  column: "Contact Phone number",
  columnTranslationKey: "common:export.columns.contactPhone",
  getter: (e: EasyTech.Prospect) => e.contact?.contactInfo?.phone || ""
}, {
  column: "address line 1",
  columnTranslationKey: "common:export.columns.addressLine1",
  getter: (e: EasyTech.Prospect) => e.customer?.address?.address || ""
}, {
  column: "address line 2",
  columnTranslationKey: "common:export.columns.addressLine2",
  getter: (e: EasyTech.Prospect) => e.customer?.address?.addressCompl || ""
}, {
  column: "zip code",
  columnTranslationKey: "common:export.columns.zipCode",
  getter: (e: EasyTech.Prospect) => e.customer?.address?.zipCode || ""
}, {
  column: "city",
  columnTranslationKey: "common:export.columns.city",
  getter: (e: EasyTech.Prospect) => e.customer?.address?.city || ""
}, {
  column: "country",
  columnTranslationKey: "common:export.columns.country",
  getter: (e: EasyTech.Prospect) => e.customer?.address?.country || ""
}, {
  column: "lat",
  columnTranslationKey: "common:export.columns.latitude",
  getter: (e: EasyTech.Prospect) => e.location?.latitude ? String(e.location.latitude) : ""
}, {
  column: "long",
  columnTranslationKey: "common:export.columns.longitude",
  getter: (e: EasyTech.Prospect) => e.location?.longitude ? String(e.location.longitude) : ""
}, {
  column: "Company E-mail address",
  columnTranslationKey: "common:export.columns.companyEmail",
  getter: (e: EasyTech.Prospect) => e.customer?.contactInfo?.email || ""
}, {
  column: "Company Phone number",
  columnTranslationKey: "common:export.columns.companyPhone",
  getter: (e: EasyTech.Prospect) => e.customer?.contactInfo?.phone || ""
}, {
  column: "Customer status",
  columnTranslationKey: "common:export.columns.customerStatus",
  // Même colonne que l'export clients, désormais rendue par les mêmes clés : ce switch renvoyait de
  // l'anglais en dur, donc cette cellule restait anglaise dans un fichier par ailleurs traduit.
  getter: (e: EasyTech.Prospect) =>
    e.customer?.type ? t(`client:type.${String(e.customer.type).toLowerCase()}`) : ""
}, {
  column: "remark",
  columnTranslationKey: "common:export.columns.remark",
  getter: (e: EasyTech.Prospect) => e.remarks
}, {
  column: "status",
  columnTranslationKey: "common:status",
  getter: (e: EasyTech.Prospect) => e.status || ""
}];
/***/
